export default __webpack_public_path__ + "static/media/bat.a73d919a.svg";